const axios = require('axios')
const querystring = require('querystring')

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

function fetchCards(cards = []) {
  return HTTP.get(`cards/?${querystring.stringify({ 'id': cards })}`)
}
function fetchAllCards() {
  return HTTP.get('cards/')
}

export default {
  fetchCards,
  fetchAllCards
}
